import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';

const mapContainerStyle = {
  width: '100%',
  height: '400px',
};

const center = {
  lat: 9.0300, // Latitude for Addis Ababa
  lng: 38.7400, // Longitude for Addis Ababa
};

const Connect = () => {
  const googleMapsApiKey = 'YOUR_GOOGLE_MAPS_API_KEY'; // Replace with your API key

  return (
    <div className="min-h-full px-4 sm:px-6 lg:px-8 pt-20">
      <div className="mt-8 flex flex-col md:flex-row">
        <div className="flex-1 md:flex-none md:w-1/2 p-4">
          <h1 className="text-gray-800 text-2xl font-extrabold">
            Our office is located in the Beautiful City of Addis Ababa
          </h1>
          <p className="mt-4 text-lg">
            We like our home like we like our designs; clean and minimal. We’re based in the heart of beautiful Addis Ababa. Don’t hesitate to visit. We have an open door policy.
            Addis Ababa Light Rail - Leghar  
Behind Amhara Bank HQ


            
          </p>
          <button className="rounded bg-[#FD5F20] m-4 px-6 py-3 font-semibold text-gray-200">
            <FontAwesomeIcon icon={faMapMarkedAlt} className="text-red-800 text-2xl" />
            {' '}
            <a href='https://maps.app.goo.gl/otqJyc8S8fMb25sY6'>
            Use This Live Location to Our Office
            </a>
          </button>
        </div>

        <div className="flex-1 md:flex-none md:w-1/2 p-4">
  {/* Google Map */}
  <div className="w-full">
    <iframe
   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1970.2862738239712!2d38.75283208871884!3d9.01142070540557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85fd100a874b%3A0xe48629093a1b5553!2sNuna%20Ethiopia!5e0!3m2!1sen!2set!4v1747988862291!5m2!1sen!2set"  
      allowFullScreen=""
      
      referrerPolicy="no-referrer-when-downgrade"
      className="rounded-lg  w-full h-60"
    ></iframe>
  </div>
</div>

      </div>
    </div>
  );
};

export default Connect;
